import { render, staticRenderFns } from "./x-icon.vue?vue&type=template&id=0828a8c6&"
import script from "./x-icon.vue?vue&type=script&lang=js&"
export * from "./x-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports